import InfoIcon from '@mui/icons-material/Info';
import { IconButton, Tooltip, Typography } from '@mui/material';
import type { ReactNode } from 'react';

import { campaignManagerTheme } from '@campaign-manager/theme';

interface Props {
  label: ReactNode;
  tooltipText?: string | ReactNode;
  id?: string;
  tooltipId?: string;
}

export default function FormInputRowLabel({ label, tooltipText, id, tooltipId }: Props) {
  return (
    <Typography
      component="div"
      sx={{
        color: campaignManagerTheme.color.grey,
        display: 'flex',
        direction: 'row',
        alignItems: 'center',
        wordBreak: 'keep-all',
        minHeight: '32px',
        fontSize: 'inherit',
      }}
      id={id}
    >
      {label}
      {tooltipText && (
        <Tooltip
          title={tooltipText}
          id={tooltipId}
        >
          <IconButton
            size="small"
            sx={{ ml: 1 }}
            aria-label={`More information about ${typeof label === 'string' ? label : 'this field'}`}
            aria-describedby={tooltipId}
          >
            <InfoIcon fontSize="inherit" />
          </IconButton>
        </Tooltip>
      )}
    </Typography>
  );
}
